import ReportExpiredPage from "@/shared/components/error-pages/report-expired-page";
import { normalizeHttpError } from "@/shared/utils/errors/http-error.factory";
import { useRouteError } from "react-router-dom";

const ReportDownloadErrorPage = () => {
  const error = useRouteError();
  // Normalize the error to use HttpError methods
  const httpError = normalizeHttpError(error);

  if (httpError.errorCode === "report_expired") {
    return <ReportExpiredPage />;
  }

  // Propage to main error boundary
  throw error;
};

export default ReportDownloadErrorPage;
